import Sidebar from "../../components/sidebar/Sidebar";
import React from "react";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import ServiceManagementDatatable from "./components/ServiceManagementDatatable";


const ServiceManagement = () => {
	return (
		<>
			<Sidebar />

			<MainSection>
				<SectionHeader title="Service Management" />

				{/* Table structure for jQuery DataTable */}

				<DatatableSection>
					<ServiceManagementDatatable />
				</DatatableSection>
			</MainSection>
		</>
	);
};

export default ServiceManagement;
